/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as React from 'react';

export default class Alert extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.setState({ children: this.props.children });
        }
    }

    render() {
        let n = 0;
        let type = this.props.type ?? 'info';
        let icon = this.props.icon ?? 'InfoCircle';
        if (this.props.variant)
            type = this.props.variant;
        return (<div className={'alert alert-' + type + (this.props.className ? ' ' + this.props.className : '')}>
            {!this.props.noIcon ? <FontAwesomeIcon icon={fa['fa' + icon]} className="me-2" /> : ''}
            {this.props.children ? (this.props.children.map ? this.props.children.map((obj) => (<span key={n++}>{obj}</span>)) : this.props.children) : this.props.message}
        </div >);
    }
}

